// @ts-nocheck
import React, { Fragment } from 'react';
import device from 'common/support/device';
import styles from './AriaTextToSpeech.module.scss';

const AriaTextToSpeech = () => {
  return (
    device.useAriaAccessibility && (
      <Fragment>
        <div
          className={styles.ariaHidden}
          id="aria-hidden-1"
          role="presentation"
          tabIndex="-1"
        />
        <div
          className={styles.ariaHidden}
          id="aria-hidden-2"
          role="presentation"
          tabIndex="-1"
        />
        <div
          className={styles.ariaHidden}
          id="aria-hidden-stop"
          aria-label=""
          role="presentation"
          tabIndex="-1"
        />
      </Fragment>
    )
  );
};

export default AriaTextToSpeech;
